(function () {
  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  function fire(el) {
    el.dispatchEvent(new Event("input", { bubbles: true }));
    el.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function setValue(el, val) {
    if (!el) return false;
    el.value = val;
    fire(el);
    return true;
  }

  function text(el) {
    return ((el && el.textContent) || "").trim().toLowerCase();
  }

  function findByLabelContains(labelNeedle) {
    labelNeedle = (labelNeedle || "").toLowerCase();
    for (const lbl of qa("label")) {
      if (!text(lbl).includes(labelNeedle)) continue;

      const forId = lbl.getAttribute("for");
      if (forId) {
        const el = document.getElementById(forId);
        if (el) return el;
      }

      const wrapped = lbl.querySelector("input, textarea, select, button, [role='combobox']");
      if (wrapped) return wrapped;

      const parent = lbl.parentElement;
      if (parent) {
        const near = parent.querySelector("input, textarea, select, button, [role='combobox']");
        if (near) return near;
      }
    }
    return null;
  }

  // --- Step A: Try normal <select> ---
  function trySelectDropdown() {
    const sel = findByLabelContains("artwork type");
    if (sel && sel.tagName === "SELECT") {
      const opt = qa("option", sel).find(o => text(o).includes("use store design"));
      if (opt) return setValue(sel, opt.value);
    }

    // fallback: any select that has "Use Store Design"
    for (const s of qa("select")) {
      const opt = qa("option", s).find(o => text(o).includes("use store design"));
      if (opt) return setValue(s, opt.value);
    }
    return false;
  }

  // --- Step B: Try radio buttons (sometimes Globo renders as radios) ---
  function tryRadioList() {
    // Look for any label that literally says Use Store Design and click it
    const labels = qa("label").filter(l => text(l).includes("use store design"));
    if (!labels.length) return false;

    // Prefer labels that are near "Artwork Type"
    const artworkTypeLabel = qa("label").find(l => text(l).includes("artwork type"));
    if (artworkTypeLabel) {
      const box = artworkTypeLabel.closest("div, fieldset, .globo-form-item, .globo-option") || document;
      const near = qa("label", box).find(l => text(l).includes("use store design"));
      if (near) { near.click(); return true; }
    }

    labels[0].click();
    return true;
  }

  // --- Step C: Try custom combobox/listbox dropdown UI ---
  function tryCustomDropdown() {
    // Find a combobox trigger near Artwork Type
    let trigger = findByLabelContains("artwork type");

    // If the label returns a container, hunt for the trigger inside it
    if (trigger && trigger.tagName !== "BUTTON" && trigger.getAttribute("role") !== "combobox") {
      const wrap = trigger.closest("div, fieldset, .globo-form-item, .globo-option, .product-form__input") || trigger;
      trigger =
        q("[role='combobox']", wrap) ||
        q("button[aria-haspopup='listbox']", wrap) ||
        q("button", wrap);
    }

    // Fallback: any combobox on the page (only if there aren’t many)
    if (!trigger) {
      const combos = qa("[role='combobox'], button[aria-haspopup='listbox']");
      if (combos.length === 1) trigger = combos[0];
    }

    if (!trigger) return false;

    // Open it
    trigger.click();

    // Find an option containing Use Store Design and click it
    const option =
      qa("[role='option'], li, button, div").find(el => text(el) === "use store design") ||
      qa("[role='option'], li, button, div").find(el => text(el).includes("use store design"));

    if (!option) return false;

    option.click();
    return true;
  }

  function setArtworkTypeToStore() {
    return trySelectDropdown() || tryRadioList() || tryCustomDropdown();
  }

  function findArtworkCodeInput() {
    const byLabel = findByLabelContains("artwork code");
    if (byLabel && (byLabel.tagName === "INPUT" || byLabel.tagName === "TEXTAREA")) return byLabel;

    const fields = qa("input, textarea").filter(el => {
      const name = (el.getAttribute("name") || "").toLowerCase();
      const id = (el.getAttribute("id") || "").toLowerCase();
      const ph = (el.getAttribute("placeholder") || "").toLowerCase();
      return name.includes("artwork") || id.includes("artwork") || ph.includes("artwork");
    });

    return fields[0] || null;
  }

  function showConfirmation(code) {
    const wrap = document.getElementById("ccl-selected-design");
    const span = document.getElementById("ccl-selected-design-code");
    if (!wrap || !span) return;
    span.textContent = code;
    wrap.style.display = "block";
  }

  function cleanUrl() {
    const url = new URL(window.location.href);
    url.searchParams.delete("design");
    url.searchParams.delete("type");
    window.history.replaceState({}, "", url.toString());
  }

  document.addEventListener("DOMContentLoaded", function () {
    const design = getParam("design");
    if (!design) return;

    // Only on product pages
    if (!window.location.pathname.includes("/products/")) return;

    let tries = 0;
    const timer = setInterval(function () {
      tries++;

      // 1) Try to select "Use Store Design"
      setArtworkTypeToStore();

      // 2) Once the code field exists (Globo reveals it), fill it
      const codeField = findArtworkCodeInput();
      if (codeField) {
        setValue(codeField, design);
        showConfirmation(design);
        cleanUrl();
        clearInterval(timer);
      }

      if (tries > 60) clearInterval(timer); // ~6 seconds
    }, 100);
  });
})();
